import type { ApiErrorShape } from "../shared/types";

export class ApiError extends Error {
  constructor(public code: string, message: string, public fields?: Record<string, string[]>) {
    super(message);
  }
}

export async function api<T>(path: string, options?: RequestInit): Promise<T> {
  const response = await fetch(`/api${path}`, {
    ...options,
    headers: {
      ...(options?.body ? { "content-type": "application/json" } : {}),
      ...options?.headers,
    },
  });
  if (!response.ok) {
    let body: ApiErrorShape | null = null;
    try { body = await response.json() as ApiErrorShape; } catch { /* non-json failure */ }
    if (response.status === 401 && path !== "/auth/login") window.dispatchEvent(new Event("timeflow:unauthorized"));
    throw new ApiError(body?.error.code ?? "REQUEST_FAILED", body?.error.message ?? "请求失败，请稍后重试。", body?.error.fields);
  }
  const body = await response.json() as { data: T };
  return body.data;
}

export const jsonOptions = (method: string, body?: unknown): RequestInit => ({
  method,
  body: body === undefined ? undefined : JSON.stringify(body),
});

export async function downloadFile(path: string): Promise<void> {
  const response = await fetch(`/api${path}`);
  if (!response.ok) throw new ApiError("DOWNLOAD_FAILED", "导出失败，请稍后重试。");
  const blob = await response.blob();
  const disposition = response.headers.get("content-disposition") ?? "";
  const filename = disposition.match(/filename="([^"]+)"/)?.[1] ?? "timeflow-export";
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = filename;
  anchor.click();
  URL.revokeObjectURL(url);
}
